import { fetchLinkups, fetchUserLinkups } from '../../ducks/linkups.duck';

export const loadData = () => (dispatch, getState) => {
  const state = getState();
  const currentUser = state.user?.currentUser;
  const userId = currentUser?.id?.uuid;

  const requests = [dispatch(fetchLinkups({ limit: 24 }))];

  if (userId) {
    requests.push(dispatch(fetchUserLinkups(userId)));
  }

  return Promise.all(requests);
};
